import { defineMessages } from 'react-intl';
export default defineMessages({
  muiselectDate: {
    id: 'mui.selectDate',
    defaultMessage: '选择日期',
  },
  muiconfirm: {
    id: 'mui.confirm',
    defaultMessage: '确定',
  },
  muiselectCountry: {
    id: 'mui.selectCountry',
    defaultMessage: '选择国家',
  },
  muiinputPN: {
    id: 'mui.inputPN',
    defaultMessage: '请输入手机号码',
  },
  muiinputVerificationCode: {
    id: 'mui.inputVerificationCode',
    defaultMessage: '请输入验证码',
  },
  muisetPassWord: {
    id: 'mui.setPassWord',
    defaultMessage: '请设置6位数字密码',
  },
  muiclickToGet: {
    id: 'mui.clickToGet',
    defaultMessage: '点击获取',
  },
  muigetVerification: {
    id: 'mui.getVerification',
    defaultMessage: '获取验证码',
  },
  muiPNPrompt: {
    id: 'mui.PNPrompt',
    defaultMessage: '请输入正确的手机号',
  },
  muiverificationPrompt: {
    id: 'mui.verificationPrompt',
    defaultMessage: '请输入正确的验证码',
  },
  muiPWPrompt: {
    id: 'mui.PWPrompt',
    defaultMessage: '请输入正确的密码',
  },
  muisamePrompt: {
    id: 'mui.samePrompt',
    defaultMessage: "('请勿输入相同号码')",
  },
  muireGet: {
    id: 'mui.reGet',
    defaultMessage: '重新获取',
  },
  muiLikeForYou: {
    id: 'mui.LikeForYou',
    defaultMessage: '为你点赞',
  },
  muilikesContent1: {
    id: 'mui.likesContent1',
    defaultMessage: '贴心',
  },
  muilikesContent2: {
    id: 'mui.likesContent2',
    defaultMessage: '笑容甜美',
  },
  muiinputComment: {
    id: 'mui.inputComment',
    defaultMessage: '请输入简短评论...',
  },
  muievaluation: {
    id: 'mui.evaluation',
    defaultMessage: '评价',
  },
  muievaluateService: {
    id: 'mui.evaluateService',
    defaultMessage: '评价一下我的服务吧',
  },
  muisubmit: {
    id: 'mui.submit',
    defaultMessage: '提交',
  },
  muiLikes: {
    id: 'mui.Likes',
    defaultMessage: '点赞',
  },
  muiLiked: {
    id: 'mui.Liked',
    defaultMessage: '您已经点过赞了',
  },
  muilocateFailed: {
    id: 'mui.locateFailed',
    defaultMessage: '定位失败，请打开手机GPS并刷新页面重试',
  },
  muimapLoading: {
    id: 'mui.mapLoading',
    defaultMessage: '地图加载中...',
  },
  muimapLoadFailed: {
    id: 'mui.mapLoadFailed',
    defaultMessage: '地图加载失败了，请刷新重试',
  },
  muiinputKeyWord: {
    id: 'mui.inputKeyWord',
    defaultMessage: '请录入关键字',
  },
  muidiningRoom: {
    id: 'mui.diningRoom',
    defaultMessage: '食堂',
  },
  muichangeCity: {
    id: 'mui.changeCity',
    defaultMessage: '没找到？点我切换城市...',
  },
  muinearbyStore: {
    id: 'mui.nearbyStore',
    defaultMessage: '附近门店',
  },
  muiRecommend: {
    id: 'mui.Recommend',
    defaultMessage: '推荐',
  },
  muihotCity: {
    id: 'mui.hotCity',
    defaultMessage: '热门城市',
  },
  muipaySuccess: {
    id: 'mui.paySuccess',
    defaultMessage: '余额已成功支付',
  },
  muistillNeedPay: {
    id: 'mui.stillNeedPay',
    defaultMessage: '还需支付',
  },
  muigotoPay: {
    id: 'mui.gotoPay',
    defaultMessage: '{time}后跳转支付剩余金额',
  },
  muicancel: {
    id: 'mui.cancel',
    defaultMessage: '取消',
  },
  muiLoadMapFailed: {
    id: 'muiLoadMapFailed',
    defaultMessage: '地图加载失败了，请',
  },
  muiRefreshMap: {
    id: 'muiRefreshMap',
    defaultMessage: '刷新重试',
  },
  muiUpgradeNot:{
    'id': 'muiUpgradeNot',
    'defaultMessage': '暂不升级',
  },
  muiUpgradeNow:{
    'id': 'muiUpgradeNow',
    'defaultMessage': '立即升级',
  },
  muiAssetMergerMsg:{
    'id': 'muiAssetMergerMsg',
    'defaultMessage': '经检测您的手机号已被绑定，选择升级账户将自动合并您可能存在多份资产哦！',
  },
  muiGetCodeFirst: {
    id: 'muiGetCodeFirst',
    defaultMessage: '请先获取验证码',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/mui/index.js